import React from "react";
import "./CircleProgress.css";

type CircleProgressBarProps = {
  percentage: number;
  circleWidth: number;
};

const CircleProgressBar = (props: CircleProgressBarProps) => {
  const radius = 50;
  const dashArray = radius * Math.PI * 2;
  const { percentage, circleWidth } = props;
  const dashOffset = dashArray - (dashArray * percentage) / 100;

  const colorHandler = (percentage: number) => {
    if (percentage > 0 && percentage < 59) {
      return "#f2272e";
    } else if (percentage > 60 && percentage < 79) {
      return "#fcdb32";
    } else {
      return "#41b048";
    }
  };
  return (
    <div className="flex flex-col">
      <svg
        width={circleWidth}
        height={circleWidth}
        viewBox={`0 0 ${circleWidth} ${circleWidth}`}
      >
        <circle
          cx={circleWidth / 2}
          cy={circleWidth / 2}
          strokeWidth="15px"
          r={radius}
          className="circle-background"
        />
        <circle
          cx={circleWidth / 2}
          cy={circleWidth / 2}
          strokeWidth="15px"
          r={radius}
          className="circle-progress"
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset,
            stroke: colorHandler(percentage),
          }}
          transform={`rotate(-90 ${circleWidth / 2} ${circleWidth / 2})`}
        />
        <text
          x="50%"
          y="50%"
          dy="0.3em"
          textAnchor="middle"
          className="circle-text"
        >
          {Math.round(percentage)}%
        </text>
        <text
          x="50%"
          y="60%"
          dy="0.3em"
          textAnchor="middle"
          className="circle-text-label"
        >
          {"Overall Score"}
        </text>
      </svg>
      {/* <div className="flex items-center space-x-2 ">
        <div className="flex items-center space-x-1">
          <div className="h-3 w-3 bg-red-500"></div>
          <div className="text-[13px]">0 - 59</div>
        </div>
        <div className="flex items-center space-x-1">
          <div className="h-3 w-3 bg-yellow-500"></div>
          <div className="text-[13px]">60 - 79</div>
        </div>
        <div className="flex items-center space-x-1">
          <div className="h-3 w-3 bg-green-500"></div>
          <div className="text-[13px]">80 - 100</div>
        </div>
      </div> */}
    </div>
  );
};

export default CircleProgressBar;
